import * as React from 'react';

import './CountBadge.scss';

interface CountBadgeProps {
  count: number;
  maxCount?: number;
}

export const CountBadge = ({ count, maxCount = 9 }: CountBadgeProps) => {
  const countNumber = count > maxCount ? `${maxCount}+` : count;

  return (
    <div styleName="count-badge">
      {countNumber}
    </div>
  );
};

export default CountBadge;
